import { useState } from 'react'

import { createEditor, Descendant, Editor } from 'slate'
import { Slate, withReact } from 'slate-react'

export type SlatePluginFn = (editor: Editor) => Editor

type SlateProviderProps = {
    children: React.ReactNode
    plugins: SlatePluginFn[]
    initialValue: Descendant[]
}

export const SlateProvider = (props: SlateProviderProps) => {
    const [editor] = useState(() => {
        let e = withReact(createEditor())

        for (const plugin of props.plugins) {
            e = plugin(e)
        }

        return e
    })

    return (
        <Slate editor={editor} initialValue={props.initialValue}>
            {props.children}
        </Slate>
    )
}
